// Libellés, couleurs et icônes des pannes.
import React from 'react';
import {
  BoltOutlined, BuildOutlined, LocalShippingOutlined, PrecisionManufacturingOutlined, VerticalAlignBottomOutlined, VibrationOutlined,
} from '@mui/icons-material';

export const CATEGORIES = {
  BETONNIERE: { label: 'Bétonnière', icon: PrecisionManufacturingOutlined, exemple: 'ex. Bétonnière n°2' },
  VIBRATEUR: { label: 'Vibrateur', icon: VibrationOutlined, exemple: 'ex. Vibrateur aiguille 50 mm' },
  MONORAIL: { label: 'Monorail', icon: VerticalAlignBottomOutlined, exemple: 'ex. Monorail 10 t, palan, chariot de translation' },
  VEHICULE: { label: 'Véhicule', icon: LocalShippingOutlined, exemple: 'ex. Camion grue DK-1234-AB' },
  ELECTRICITE: { label: 'Électricité', icon: BoltOutlined, exemple: 'ex. Coffret général atelier, groupe électrogène' },
  AUTRE: { label: 'Autre', icon: BuildOutlined, exemple: 'ex. Compresseur, cisaille à fer' },
};

export const GRAVITES = {
  ARRET: { label: 'Production arrêtée', court: 'Arrêt', color: 'error', bg: '#F8E1E2', fg: '#B4232A' },
  DEGRADE: { label: 'Fonctionnement dégradé', court: 'Dégradé', color: 'warning', bg: '#FBF0DA', fg: '#8A5A0B' },
  MINEURE: { label: 'Mineure', court: 'Mineure', color: 'default', bg: '#EEF1F6', fg: '#5B6675' },
};

export const STATUTS = {
  DECLAREE: { label: 'Déclarée', color: 'error' },
  EN_REPARATION: { label: 'En réparation', color: 'warning' },
  RESOLUE: { label: 'Réparée', color: 'success' },
  ANNULEE: { label: 'Annulée', color: 'default' },
};

export const CategorieIcon = ({ categorie, ...props }) => {
  const Icon = (CATEGORIES[categorie] || CATEGORIES.AUTRE).icon;
  return <Icon {...props} />;
};

const p2 = (n) => String(n).padStart(2, '0');
/** Date → valeur d'un champ « datetime-local » (heure locale). */
export const versChamp = (d = new Date()) => {
  const x = new Date(d);
  return `${x.getFullYear()}-${p2(x.getMonth() + 1)}-${p2(x.getDate())}T${p2(x.getHours())}:${p2(x.getMinutes())}`;
};
/** Champ « datetime-local » → heure UTC envoyée au serveur. */
export const versServeur = (v) => (v ? new Date(v).toISOString().slice(0, 16) : '');
